import createLucideIcon from '../createLucideIcon';

const Underline = createLucideIcon('Underline', [
  ['path', { d: 'M6 4v6a6 6 0 0 0 12 0V4', key: '9kb039' }],
  ['line', { x1: '4', x2: '20', y1: '20', y2: '20', key: 'nun2al' }],
]);

export default Underline;
